// extracted by mini-css-extract-plugin
module.exports = {"page":"_5D3UTTmh","card":"_5D2Dw8Je","account-details":"_5D2CCPQG","invitations-content":"_5D2YVPye","invitations-item":"_5DM0uCgA"};